// extracted by mini-css-extract-plugin
module.exports = {"pagination":"dfa16c80 ma0","page":"_26391339 dib","current":"_31dfe8f0","first":"a0329937","last":"_766d2bab"};